import { convertLabelMapToConfig, mergeConfig } from '../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.SamplingDetails.ContractorName`]: `Contractor`,
      [`${prefix}.SamplingDetails.SampledBy`]: `Sampled By`,
      [`${prefix}.SamplingDetails.SamplingMethod`]: `Sampling Method`,
      [`${prefix}.SamplingDetails.Weather`]: `Weather`,
      [`${prefix}.SamplingDetails.SupplierName`]: `Supplier`,
      [`${prefix}.SamplingDetails.SourceName`]: `Source`,
      [`${prefix}.SamplingDetails.Material`]: `Material`,
      [`${prefix}.SamplingDetails.MaterialType`]: `Material Type`,
      [`${prefix}.SamplingDetails.GeneralLocation`]: `General Location`,
      [`${prefix}.SamplingDetails.Location`]: `Location`,
      [`${prefix}.SamplingDetails.SamplePickupNotes`]: `Sample Pickup Notes`,
      [`${prefix}.SamplingDetails.BatchSize`]: `Size of Batch`,
      [`${prefix}.SamplingDetails.BatchNature`]: `Nature of Batch`,
      [`${prefix}.SamplingDetails.CalculateMinimumSampleMass`]: `Calculate minimum sample mass`,
      [`${prefix}.SamplingDetails.MinimumSampleMassRequired`]: `Minimum Sample Mass Required`,
      [`${prefix}.SamplingDetails.MassPerIncrement`]: `Approx. Mass per Increment`,
      [`${prefix}.SamplingDetails.NoIncrementsRequired`]: `Number of Increments Required`,
      [`${prefix}.SamplingDetails.SamplingApparatus`]: `Sampling Apparatus`,
      [`${prefix}.SamplingDetails.SampleReduction`]: `Sample Reduction By`,
      [`${prefix}.SamplingDetails.Balance`]: `Balance`,
      [`${prefix}.SamplingDetails.NominalAggregateSize`]: `Nominal Aggregate Size `,
      [`${prefix}.SamplingDetails.BalanceSuitable`]: `Balance is suitable for use`,
      [`${prefix}.SamplingDetails.SamplingType`]: `Type of Sampling`,

      [`${prefix}.SamplingDetails.SampleBags.SampleBags.BagMass`]: `Mass`,
      [`${prefix}.SamplingDetails.SampleBags.SampleBags.IncrementsCount`]: `Increments`,

      [`${prefix}.SamplingDetails.NoBag`]: `Number of Bags/Containers`,
      [`${prefix}.SamplingDetails.IncrementsCount`]: `Number of Increments`,
      [`${prefix}.Results.SampleMass`]: `Mass of Sample`,
    })
  );

export default getLabelConfig;
